/* eslint-disable react/prop-types */
import classes from './Accordion.module.scss' ;
// import {menus} from './SliderData' ;
import {useState} from 'react'
import { FaAngleDown,  FaAngleUp } from "react-icons/fa";

const menus = [
    {title : 'Our Mission' , content : 'At Millensys, our mission is to revolutionize healthcare globally reliable AI-powered solutions. We develop and deliver reliable, eco-friendly solutions that empower healthcare professionals and stakeholders to save time, improve patient outcomes, and optimize revenues. Supported by timely and responsive customer support, and guided by our core values.'},
    {title : 'Our Vision' , content : 'MILLENSYS Vision is to be a global market leader in innovative , high quality and cost effective healthcare , medical imaging and commercial software IT solutions in its targeted markets. MILLENSYS shall be highly committed to its customers and targeted markets by insuring the delivery of innovative solutions, cost effective and high quality integrated services through its high qualified and well trained staff. MILLENSYS shall work with its maximum efforts to present continuously updated information technology to better serve its customers in its targeted markets.'},
    {title : 'Our Goals' , content : 'Providing a unique unified healthcare management information platform to manage a whole healthcare ecosystem from a single place Develop brand awareness and acceptance for our product line around the globe Maintaining a positive and strong growth each year. Achieving a stable market share increase with a market penetration strategy in some markets and Diversification in others. Continue to develop MILLENSYS image as the leader in innovative solutions provider in medical IT and beyond.'},
    {title : 'Our Values' , points : ['-Transparency','-Innovation','-Outcome-Driven','-Commitment']}
]

const Card = ({title , overview ,points })=>{
    const [isOpen,setIsOpen] = useState(false);
    const onClickHndler =()=>{
        setIsOpen(prev => !prev )
    }
    return(
        <article className={`${classes.fque} ${isOpen && classes.open} `}>
        <div className={classes["f__icon"]} onClick={onClickHndler} >
        {!isOpen? <span><FaAngleDown className={classes.icon_} /></span> : <span><FaAngleUp className={classes.icon_} /></span>}
        <h4>{title}</h4>
        </div>
        <div className={classes["f__answer"]}>
            {overview && <p>{overview}</p>}
            {points && <p>{points[0]}</p>}
            {points && <p>{points[1]}</p>}
            {points && <p>{points[2]}</p>}
            {points && <p>{points[3]}</p>}
        </div>
    </article>
    )
}


function Accordion() {
    const content = `Healthcare providers trust MILLENSYS as a single vendor to almost all needed management software for their business.
    With a wide range of software products portfolio ranging from clinical,
    imaging, worflow, automation, telehealth to financial management; competition is normally minimal.`
    return (
        <section className={`${classes["fques"]} ${classes["section__container"]} `}>
        <p className={classes["section__subheader"]}>MILLENSYS quick guide</p>
        {/* <h2 className={classes["section__header"]}>An Ecosystem of Healthcare Innovation</h2> */}
        <p className={classes["__strong"]}>
            {content}
        </p>
        <div className={`${classes["fque__container"]} container`}>
            {menus.map((ele,i)=>{return((<Card  key={i} title={ele.title} overview={ele.content?ele.content:null} points={ele.points?ele.points:null}/>))})}
        </div>
    </section>
    )
}

export default Accordion
